import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;
const token = localStorage.getItem("token");

export const getAllBasesByCompanyId = async (companyId) => {
  try {
    const bases = await axios.get(
      `${backendUrl}/bases/companybases/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return bases.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getBasesWithNoContainerAndProbeIdByCompanyId = async (
  companyId
) => {
  try {
    const bases = await axios.get(
      `${backendUrl}/bases/baseswithnocontainerandprobeid/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return bases.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllBasesInContainersByCompanyId = async (companyId) => {
  try {
    const bases = await axios.get(
      `${backendUrl}/bases/basesincontainers/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return bases.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllBasesInContainersWithLogoutDateByCompanyId = async (
  companyId
) => {
  try {
    const bases = await axios.get(
      `${backendUrl}/bases/basesincontainerswithlogoutdate/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return bases.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getBases = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams
      ? `${backendUrl}/bases?${queryParams}`
      : `${backendUrl}/bases`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Fetches all bases that are not currently connecting.
 * These bases are not actively communicating with the system.
 * @returns {Promise<Array>} Returns a promise that resolves to an array of bases not connecting
 */
export const getNotConnectingBases = async (filters = "") => {
  try {
    // Optional company filter
    const url = filters.companyid
      ? `${backendUrl}/bases/notconnectingbases?companyid=${filters.companyid}`
      : `${backendUrl}/bases/notconnectingbases`;

    const response = await axios.get(url, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 *  Fetches all unassigned bases.
 *  Unassigned bases are those that do not have a product assigned.
 * @returns {Promise<Array>} Returns a promise that resolves to an array of unassigned bases.
 */
export const getUnassignedBases = async () => {
  try {
    const response = await axios.get(`${backendUrl}/bases/unassigned-bases`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// UPDATE

export const updateBaseContainerIdByBaseId = async (baseId, containerId) => {
  try {
    const updatedBaseContainerId = await axios.patch(
      `${backendUrl}/bases/updatebasecontainerid/${baseId}`,
      { containerid: containerId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return updatedBaseContainerId.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateBaseInDataBases = async (baseId, baseData) => {
  try {
    const updatedBase = await axios.put(
      `${backendUrl}/bases/${baseId}`,
      baseData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return updatedBase.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const removeBaseFromContainerByBaseIdAndCompanyId = async (
  baseId,
  companyId
) => {
  try {
    const removedBaseFromContainer = await axios.patch(
      `${backendUrl}/bases/removebasefromcontainer/${baseId}/${companyId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return removedBaseFromContainer.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const connectBaseToContainer = async (
  baseId,
  containerId,
  companyId
) => {
  try {
    const connectedBaseToContainer = await axios.patch(
      `${backendUrl}/bases/connectbasetocontainer/${baseId}/${containerId}/${companyId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return connectedBaseToContainer.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const deleteBase = async (baseId) => {
  try {
    const response = await axios.delete(`${backendUrl}/bases/${baseId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
